<div class="grid-content"><ng-content></ng-content></div>
